const warehouseOptions = [
  // 'EURO',
  // 'Canada West',
  // 'FBA',
  // 'NY-HQ',
  // 'Drop Ship',
  // 'REGULAR',

  'Euro#2',
  'FOB China',
  'LA WH',
  'MIDAS',
  'MIDAS#2',
  'Pixior',
  'POE',
  'Canada East',
  'DCG',
  'MISSING'
].map(x => {return { key: x, text: x, value: x }})

export default warehouseOptions
